/* ==========================================================================
   Ryse - Theoric: o carrossel "Complete sua rotina" na PDP.
   Reusa a secao do carrinho (theoric-cart-recs). Base = o produto da pagina.

   14/08/2026 - CURADORIA DE ROTINA
   Se o produto tiver o metafield custom.rotina preenchido, o snippet
   theoric-pdp-rotina.liquid ja renderiza os cards em Liquid (na ordem dos
   protocolos da marca) dentro de [data-tpn-addon]. Neste caso este script
   apenas liga o indicador e os botoes - NAO chama a API de recomendacoes.
   Sem curadoria, mantem o comportamento antigo: complementary -> related.

   Indicador: bolinha -> tracinho no ativo. FONTE UNICA = a posicao real da
   rolagem; irPara() so rola. Largura do ponto via inline !important (a cascata
   do card do carrinho nao deixa a regra CSS vencer na PDP).
   ========================================================================== */
(function () {
  'use strict';

  var secao = document.getElementById('theoric-pdp-novo');
  if (!secao) return;
  var alvo = secao.querySelector('[data-tpn-addon]');
  if (!alvo) return;

  var SEC = 'theoric-cart-recs', LIMITE = 8;
  function temCard(html) { return !!html && html.indexOf('theoric-cart-recs__card') !== -1; }

  function handleDaPagina() {
    var p = location.pathname.split('/products/')[1] || '';
    return p.split('?')[0].split('#')[0].split('/')[0];
  }

  /* ---- 1) rotina curada, ja renderizada em Liquid ---- */
  var curado = alvo.querySelector('[data-tpn-rotina]');
  if (curado) {
    montar(curado);
    ligarBotoes(curado);
    return;
  }

  /* ---- 2) sem curadoria: API de recomendacoes (comportamento antigo) ---- */
  var PID = window.__TPN_PID;
  if (!PID) return;

  var base = '/recommendations/products?section_id=' + SEC + '&product_id=' + PID + '&limit=' + LIMITE;

  fetch(base + '&intent=complementary')
    .then(function (r) { return r.text(); })
    .then(function (html) { return temCard(html) ? html : fetch(base + '&intent=related').then(function (r) { return r.text(); }); })
    .then(function (html) {
      if (!temCard(html)) return;
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var bloco = temp.querySelector('[data-theoric-cart-recs]');
      if (!bloco) return;

      var handle = handleDaPagina();
      if (handle) {
        Array.prototype.forEach.call(bloco.querySelectorAll('.theoric-cart-recs__card'), function (card) {
          var a = card.querySelector('a[href*="/products/"]');
          if (a && a.getAttribute('href').indexOf('/products/' + handle) !== -1) card.remove();
        });
      }
      if (!bloco.querySelector('.theoric-cart-recs__card')) return;

      alvo.appendChild(bloco);
      montar(bloco);
      ligarBotoes(bloco);
    })
    .catch(function () {});

  var LARG_ON = '22px', LARG_OFF = '6px';
  function larguraPonto(el, w) {
    el.style.setProperty('width', w, 'important');
    el.style.setProperty('min-width', w, 'important');
  }

  function montar(bloco) {
    var trilho = bloco.querySelector('[data-recs-track]');
    var pontos = bloco.querySelector('[data-recs-dots]');
    if (!trilho) return;
    var cards = [].slice.call(trilho.querySelectorAll('.theoric-cart-recs__card'));
    if (cards.length < 2) { if (pontos) pontos.remove(); return; }

    var lista = [];
    if (pontos) {
      pontos.innerHTML = '';
      cards.forEach(function (card, idx) {
        var p = document.createElement('button');
        p.type = 'button';
        p.className = 'theoric-cart-recs__dot';
        larguraPonto(p, LARG_OFF);
        p.setAttribute('aria-label', 'Ver recomendado ' + (idx + 1) + ' de ' + cards.length);
        p.addEventListener('click', function () { irPara(idx); });
        pontos.appendChild(p);
        lista.push(p);
      });
    }

    var atual = -1;
    function marca(idx) {
      if (idx === atual) return;
      atual = idx;
      for (var i = 0; i < lista.length; i++) {
        var on = i === idx;
        lista[i].classList.toggle('is-active', on);
        larguraPonto(lista[i], on ? LARG_ON : LARG_OFF);
      }
    }
    function indiceAtual() {
      var max = trilho.scrollWidth - trilho.clientWidth;
      if (max <= 2) return 0;
      if (trilho.scrollLeft >= max - 2) return cards.length - 1;
      var ref = trilho.getBoundingClientRect().left + 1;
      var best = 0, dist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var d = Math.abs(cards[i].getBoundingClientRect().left - ref);
        if (d < dist) { dist = d; best = i; }
      }
      return best;
    }
    function irPara(idx) {
      var av = cards[idx].getBoundingClientRect().left - trilho.getBoundingClientRect().left;
      trilho.scrollBy({ left: av, behavior: 'smooth' });
    }

    var ticking = false;
    function aoRolar() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { marca(indiceAtual()); ticking = false; });
    }
    trilho.addEventListener('scroll', aoRolar, { passive: true });
    window.addEventListener('resize', aoRolar);
    marca(indiceAtual());
  }

  function ligarBotoes(bloco) {
    Array.prototype.forEach.call(bloco.querySelectorAll('[data-theoric-rec-add]'), function (botao) {
      botao.addEventListener('click', function () {
        var v = botao.getAttribute('data-variant-id');
        if (!v || botao.disabled) return;
        botao.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v, quantity: 1 }] }) })
          .then(function (r) { return r.json(); })
          .then(function () {
            botao.classList.add('is-added');
            var rot = botao.querySelector('span'); if (rot) rot.textContent = 'Adicionado';
            if (window.TheoricCart) { TheoricCart.sincronizar(true); if (TheoricCart.atualizarBolinha) TheoricCart.atualizarBolinha(); }
          })
          .catch(function () { botao.disabled = false; });
      });
    });
  }
})();